import App from '../app';
import {Job} from '../model/Job';
import {AnyCommand} from '../type';
import {CommandContainer} from '../../../framework/type';
import {useEffect} from 'preact/hooks';
import currentSession from './currentSession';
import {useLoadJobCommand} from '../command/loadJob';

export default function useJob(jobId: string): [Job | null, CommandContainer<AnyCommand>] {
  const {teamId} = currentSession();
  const [command, getJob] = useLoadJobCommand();

  const id = teamId.id;

  useEffect(() => {
    if (!id) return;
    getJob({teamId: id, jobId});
  }, [id, jobId]);

  const state = App.useQuery(state => {
    const team = state.team.get(id);

    if (!team) return null;

    return team.jobs.get(jobId);
  }, [id]);

  return [state, command];
}